import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import { groupByN } from "../../utility";
import DataNotFound from "../../components/DataNotFound/index";
import { useHistory } from "react-router-dom";

function PilihLayanan() {
  let history = useHistory();
  const [instansi, setInstansi] = useState([]);
  const fetchInstansi = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/internal/kuota/offline`,
        {
          params: {
            key: process.env.REACT_APP_API_KEY,
          },
        }
      );
      setInstansi(res.data);
    } catch (error) {}
  };
  useEffect(() => {
    fetchInstansi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectedIds, setSelectedIds] = useState([]);

  const layananItems = instansi ? groupByN(8, instansi) : [];

  console.log(selectedIds);
  return (
    <main>
      <div className="container">
        <div className="wrapper">
          <div className="content">
            <h1
              style={{
                textAlign: "center",
                fontSize: 32,
                marginBottom: 24,
              }}
            >
              Pilih tenant untuk ditampilkan Test
            </h1>
            {instansi.length === 0 ? (
              <div>
                <ul className="select">
                  {[...Array(8)].map((num) => (
                    <li key={num}>
                      <Skeleton height={160} />
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <>
                {layananItems.length > 0 ? (
                  <Carousel plugins={["arrows"]}>
                    {layananItems.map((group, indexGroup) => (
                      <ul className="select" key={indexGroup}>
                        {group.map((item, indexItem) => {
                          let classess = ["item"];
                          const isSelected = selectedIds.includes(item.id);
                          if (isSelected) {
                            classess.push("active");
                          }
                          return (
                            <li
                              key={indexItem}
                              onClick={() => {
                                if (!isSelected) {
                                  const newSelectedIds = selectedIds.slice();
                                  newSelectedIds.push(item.id);
                                  setSelectedIds(newSelectedIds);
                                } else {
                                  const newSelectedIds = selectedIds.slice();
                                  const targetIndex = newSelectedIds.findIndex(
                                    (i) => i === item.id
                                  );
                                  newSelectedIds.splice(targetIndex, 1);
                                  setSelectedIds(newSelectedIds);
                                }
                              }}
                              className={classess.join(" ")}
                            >
                              <img
                                src={item.gambar_layanan_url}
                                alt={"Logo " + item.nama_layanan}
                              />
                              <h3>{item.nama_layanan}</h3>
                            </li>
                          );
                        })}
                      </ul>
                    ))}
                  </Carousel>
                ) : (
                  <DataNotFound title="Tenant" />
                )}
              </>
            )}
            <button
              className="cta"
              onClick={() => {
                window.location.href = `/lihat-antrian?id=${selectedIds.join(
                  ","
                )}`;
              }}
            >
              Pilih Instansi
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

PilihLayanan.propTypes = {};
export default PilihLayanan;
